import { useSalidaService } from '@/services/salidaService'
import { useSalidaStore } from '@/store/useSalidaStore'
import { useMapData } from '@/composables/useMapData'
import { useApi } from '@/composables/useApi'

export const useSaveSalida = () => {
  const service = useSalidaService()
  const salidaStore = useSalidaStore()
  const { getMapData } = useMapData()
  const api = useApi()

  const execute = async (form) => {
    const mapData = getMapData(form.territorios)
    const { data, error } = await service.saveSalida(form, mapData)
    if (error) return { error }
    const res = await api.post('/api/salidas', data)
    if (res?.error) return { error: res.error }
    salidaStore.addSalida(data)
    return { data }
  }

  return { execute }
}
